/** Series and pie slice colours, the same order as the Widget Subscription PDF. */
export const WIDGET_SERIES_COLORS: readonly string[] = ['#5a67d8', '#e53e3e', '#38a169', '#d69e2e'];

/**
 * @param index - Position of a series or slice
 * @returns Its colour, reused in order when there are more series than colours
 */
export function seriesColor(index: number): string {
  return WIDGET_SERIES_COLORS[index % WIDGET_SERIES_COLORS.length];
}
